import React, {useEffect} from 'react';
import DatePicker from 'react-date-picker';
import FormField from 'mrf/view/FormField';
import dateFormatter from 'mrf/utils/DateFormatter';
import { CalendarIcon } from 'mrf/styles/basic/icons';
import StyledDateTimePicker from 'mrf/styles/components/DateTimePicker.styles';
import useLocale from 'mrf/utils/useLocale';
import {useFormContext, useSetFormValueByContext} from "../redux/ReduxHelper";

const valueMapper = e => e;

const DatePickerIdWrapper = ({ id, readOnly, value, changed, ...props }) => {
    const context = useFormContext(props.context)
    const set = useSetFormValueByContext(context);
    const field = props.field;

    useEffect(() => {
        if (typeof value === 'string' && value !== '') {
            set({ [field]: new Date(value) })
        }
    },[value]); // eslint-disable-line

    return readOnly
        ? <p>&nbsp;{dateFormatter(value)}</p>
        : <StyledDateTimePicker changed={changed} id={id}><DatePicker value={value} openWidgetsOnFocus={false} {...props}/></StyledDateTimePicker>
}

export default function DateField({ openOnFocus, ...props }) {
    return (
        <>
            <FormField
                component={DatePickerIdWrapper}
                locale={useLocale()}
                calendarIcon={<CalendarIcon className='icon' />}
                clearIcon={null}
                disableClock
                eventMapper={valueMapper}
                openCalendarOnFocus={openOnFocus}
                {...props}
            />
        </>
    );
}
